import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

export const SupportConversationSkeletons: React.FC = () => {
  return (
    <Root>
      <Reply style={{ width: '80%' }}>
        <Skeleton.Line />
        <Skeleton.Line />
        <Skeleton.Line />
        <DateSkeleton height={10} width={30} />
      </Reply>
      <Message style={{ width: '80%' }}>
        <Skeleton.Line />
        <Skeleton.Line />
        <DateSkeleton height={10} width={30} />
      </Message>
      <Message style={{ width: '60%' }}>
        <Skeleton.Line />
        <DateSkeleton height={10} width={30} />
      </Message>
      <Message style={{ width: '60%' }}>
        <Skeleton.Line />
        <DateSkeleton height={10} width={30} />
      </Message>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px;
  align-content: start;
`

const Reply = styled.div`
  color: var(--text-12);
  background: var(--backgroundA-2);
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  justify-self: start;

  display: grid;
  align-items: start;
  align-content: start;
  gap: 2px;
`

const Message = styled(Reply)`
  color: var(--text-11);
  background: var(--backgroundA-3);
  justify-self: end;
`

const DateSkeleton = styled(Skeleton)`
  justify-self: end;
  margin-top: 4px;
  opacity: 0.8;
`
